// ─── Siri-style waveform canvas animation ─────────────────────────────────
function initBlobCanvas(canvas) {
  var ctx = canvas.getContext('2d');
  var raf = null;
  var running = false;
  var t = 0;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var waves = [
    { freq: 1.9, phaseOffset: 0.00, amp: 1.00, speed: 0.55 },
    { freq: 2.4, phaseOffset: 1.15, amp: 0.82, speed: 0.48 },
    { freq: 1.5, phaseOffset: 2.40, amp: 0.94, speed: 0.62 },
    { freq: 2.9, phaseOffset: 0.75, amp: 0.72, speed: 0.40 },
    { freq: 1.2, phaseOffset: 3.60, amp: 0.88, speed: 0.70 },
    { freq: 3.3, phaseOffset: 1.90, amp: 0.65, speed: 0.35 },
  ];


  function resize() {
    var w = canvas.offsetWidth, h = canvas.offsetHeight;
    if (w > 0 && h > 0 && (canvas.width !== w || canvas.height !== h)) {
      canvas.width  = w;
      canvas.height = h;
    }
  }

  function envelope(xNorm) {
    var d = (xNorm - 0.5) * 2.4;
    return Math.exp(-d * d * 1.2);
  }

  function render() {
    resize();
    var w = canvas.width, h = canvas.height;
    if (!w || !h) return;
    ctx.clearRect(0, 0, w, h);

    var cy     = h * 0.5;
    var maxAmp = h * 0.36;
    var grad = ctx.createLinearGradient(0, 0, w, 0);
    grad.addColorStop(0,    'rgba(252,100,113,0.55)');
    grad.addColorStop(0.28, '#e8406a');
    grad.addColorStop(0.52, '#c2185b');
    grad.addColorStop(0.78, '#7b3fc8');
    grad.addColorStop(1.0,  'rgba(74,160,224,0.55)');

    var STEP = 3;

    waves.forEach(function (wave) {
      var phase = wave.phaseOffset + t * wave.speed;

      ctx.save();
      ctx.strokeStyle = grad;
      ctx.lineWidth   = 4;
      ctx.globalAlpha = 0.12;
      ctx.beginPath();
      for (var px = 0; px <= w; px += STEP) {
        var xn  = px / w;
        var env = envelope(xn);
        var y   = cy + env * maxAmp * wave.amp * Math.sin(wave.freq * xn * Math.PI * 2 + phase);
        px === 0 ? ctx.moveTo(px, y) : ctx.lineTo(px, y);
      }
      ctx.stroke();
      ctx.restore();

      ctx.save();
      ctx.strokeStyle = grad;
      ctx.lineWidth   = 0.9;
      ctx.globalAlpha = 0.88;
      ctx.beginPath();
      for (var px = 0; px <= w; px += STEP) {
        var xn  = px / w;
        var env = envelope(xn);
        var y   = cy + env * maxAmp * wave.amp * Math.sin(wave.freq * xn * Math.PI * 2 + phase);
        px === 0 ? ctx.moveTo(px, y) : ctx.lineTo(px, y);
      }
      ctx.stroke();
      ctx.restore();
    });
  }

  function frame() {
    if (!running) return;
    t += 0.012;
    render();
    raf = requestAnimationFrame(frame);
  }

  canvas._blobStart = function () {
    if (running) return;
    running = true;
    resize();
    if (reducedMotion) { render(); return; }
    frame();
  };

  canvas._blobStop = function () {
    running = false;
    if (raf) { cancelAnimationFrame(raf); raf = null; }
  };

  window.addEventListener('resize', resize);
}

(function () {
  document.querySelectorAll('.hero-carousel').forEach(function (carousel) {
    var slides      = Array.from(carousel.querySelectorAll('.hc-slide'));
    var navItems    = Array.from(carousel.querySelectorAll('.hc-nav-item'));
    var navStrip    = carousel.querySelector('.hc-nav-strip');
    var counter     = carousel.querySelector('.hc-counter');
    var total       = slides.length;
    var current     = 0;
    var isAnimating = false;
    var autoplayTimer = null;
    var isAutoplay  = carousel.dataset.autoplay === 'true';
    var speed       = (parseInt(carousel.dataset.autoplaySpeed, 10) || 8) * 1000;
    var FADE_MS     = 900;

    // Init blob canvases
    var allCanvases = Array.from(carousel.querySelectorAll('canvas.hc-bg-sound'));
    allCanvases.forEach(initBlobCanvas);

    function getSlideCanvas(idx) {
      return slides[idx] ? slides[idx].querySelector('canvas.hc-bg-sound') : null;
    }

    function padNum(n) {
      return (n + 1 < 10 ? '0' : '') + (n + 1);
    }

    function updateAccent() {
      var accent = navItems[current].dataset.accent;
      if (accent && navStrip) {
        navStrip.style.setProperty('--hc-strip-accent', accent);
      }
    }

    function goTo(index) {
      var target = ((index % total) + total) % total;
      if (target === current || isAnimating) return;
      isAnimating = true;

      var prev = current;
      current = target;

      // Slides
      slides[prev].classList.add('is-leaving');
      slides[prev].classList.remove('is-active');
      slides[prev].setAttribute('aria-hidden', 'true');
      slides[current].classList.add('is-active');
      slides[current].removeAttribute('aria-hidden');
      setTimeout(function () { slides[prev].classList.remove('is-leaving'); }, FADE_MS);

      // CTA tab index
      var prevCta = slides[prev].querySelector('.hc-cta');
      var nextCta = slides[current].querySelector('.hc-cta');
      if (prevCta) prevCta.setAttribute('tabindex', '-1');
      if (nextCta) nextCta.removeAttribute('tabindex');

      // Nav items
      navItems[prev].classList.remove('is-active', 'is-playing');
      navItems[prev].setAttribute('aria-selected', 'false');
      navItems[current].classList.add('is-active');
      navItems[current].setAttribute('aria-selected', 'true');

      // Counter
      if (counter) {
        counter.textContent = padNum(current) + ' / 0' + total;
      }

      // Canvas blob animations
      var prevCnv = getSlideCanvas(prev);
      var nextCnv = getSlideCanvas(current);
      if (prevCnv && prevCnv._blobStop)  prevCnv._blobStop();
      if (nextCnv && nextCnv._blobStart) nextCnv._blobStart();

      // Accent colour for nav strip
      updateAccent();

      // Autoplay progress bar
      if (isAutoplay) {
        var bar = navItems[current].querySelector('.hc-nav-bar');
        if (bar) {
          bar.style.transition = 'none';
          bar.style.width = '0';
          navItems[current].classList.remove('is-playing');
          bar.getBoundingClientRect(); // force reflow
          bar.style.transition = '';
          navItems[current].style.setProperty('--hc-progress-duration', speed + 'ms');
          navItems[current].classList.add('is-playing');
        }
      }

      setTimeout(function () { isAnimating = false; }, FADE_MS);
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    // Nav clicks
    navItems.forEach(function (item) {
      item.addEventListener('click', function () {
        stopAutoplay();
        goTo(parseInt(item.dataset.target, 10));
      });
    });

    // Keyboard
    carousel.setAttribute('tabindex', '0');
    carousel.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { stopAutoplay(); prev(); }
      if (e.key === 'ArrowRight') { stopAutoplay(); next(); }
    });

    // Touch / swipe
    var touchStartX = 0;
    var touchStartY = 0;

    carousel.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
      touchStartY = e.changedTouches[0].clientY;
    }, { passive: true });

    carousel.addEventListener('touchend', function (e) {
      var dx = touchStartX - e.changedTouches[0].clientX;
      var dy = touchStartY - e.changedTouches[0].clientY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 48) {
        stopAutoplay();
        if (dx > 0) next(); else prev();
      }
    }, { passive: true });

    // Autoplay
    function startAutoplay() {
      if (autoplayTimer) return;
      navItems[current].style.setProperty('--hc-progress-duration', speed + 'ms');
      navItems[current].classList.add('is-playing');
      autoplayTimer = setInterval(next, speed);
    }

    function stopAutoplay() {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
      navItems.forEach(function (item) {
        item.classList.remove('is-playing');
        item.style.removeProperty('--hc-progress-duration');
      });
    }

    // Pause on hover / focus
    carousel.addEventListener('mouseenter', function () { if (isAutoplay) stopAutoplay(); });
    carousel.addEventListener('mouseleave', function () { if (isAutoplay) startAutoplay(); });
    carousel.addEventListener('focusin',    function () { if (isAutoplay) stopAutoplay(); });
    carousel.addEventListener('focusout',   function () { if (isAutoplay) startAutoplay(); });

    // Init
    updateAccent();
    if (isAutoplay) startAutoplay();

    // Start blob canvas for initial slide
    var initCnv = getSlideCanvas(0);
    if (initCnv && initCnv._blobStart) initCnv._blobStart();
  });
})();
